'use client';

import { useEffect } from 'react';

function logErrorToServer(errorData: any) {
  try {
    navigator.sendBeacon('/api/client-error-log', JSON.stringify(errorData));
  } catch (err) {
    console.error('❌ Error sending log to server:', err);
  }
}

export default function ClientErrorLogger() {
  useEffect(() => {
    console.log('🚀 Client error logger initialized');

    // 1️⃣ 전역적인 JavaScript 오류 감지
    window.onerror = function (message, source, lineno, colno, error) {
      logErrorToServer({
        message,
        source,
        lineno,
        colno,
        error: error?.stack || 'No stack trace',
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      });
    };

    // 2️⃣ 리소스 로드 실패 감지 (이미지, CSS, JS 파일 등)
    window.addEventListener(
      'error',
      event => {
        if (event instanceof ErrorEvent) {
          logErrorToServer({
            message: event.message,
            source: event.filename,
            lineno: event.lineno,
            colno: event.colno,
            userAgent: navigator.userAgent,
            timestamp: new Date().toISOString(),
          });
        }
      },
      true,
    );

    // 3️⃣ Promise에서 발생하는 비동기 오류 감지
    window.addEventListener('unhandledrejection', event => {
      logErrorToServer({
        message: 'Unhandled Promise Rejection',
        reason: event.reason,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      });
    });
  }, []);

  return null; // UI 렌더링 필요 없음
}
